import Header from './components/header/Header';
// import Loading from './components/spinners/Loading';
import Views from './Views/Views';

const App = () => (
  <>
    <Header />
    <Views />
  </>
);

export default App;
